export default __webpack_public_path__ + "static/media/dreamstime_xs_121862608.f42c486e.jpg";